export const applications = [
	{ name: 'LumiData', url: 'https://lumidata.com', icon: 'ft-database item-badge mb-4', logo: "" },
	{ name: 'LumiBackOffice', url: 'https://lumibackoffice.com', icon: 'ft-activity item-badge mb-4', logo: "" },
	{ name: 'LumiBridge', url: 'https://lumibridge.com', icon: 'ft-globe item-badge mb-4', logo: "" },
	{ name: 'LumiFlow', url: 'https://lumiflow.com', icon: 'ft-layers item-badge mb-4', logo: "" },
	{ name: 'LumiPlay Engine', url: 'https://lumiplay.net', icon: 'ft-airplay item-badge mb-4', logo: "logo_lumiplay.png" },
	{ name: 'MountainLive', url: 'https://mountain-live.com', icon: 'ft-triangle item-badge mb-4', logo: "logo-mountain-live.png" }
];
